import { render, staticRenderFns } from "./EducationalJoiningApplicationChangeApprove.vue?vue&type=template&id=1391cf26&"
import script from "./EducationalJoiningApplicationChangeApprove.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationChangeApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports